import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

class PaySuccess extends Component {
  static propTypes = {
    history: PropTypes.instanceOf(Object).isRequired,
    location: PropTypes.instanceOf(Object).isRequired,
    inquiry_no: PropTypes.string.isRequired,
  }

  state = {
    count: 5,
    redirect_url: '',
  }

  componentDidMount() {
    const { location } = this.props;
    const state = location.state || {};
    const redirect_url = state.redirect_url || false;
    if (!redirect_url) {
      const { history, inquiry_no } = this.props;
      history.push(`/${inquiry_no}`);
      return;
    }
    this.setState({
      redirect_url,
    });
    this.tmr = setInterval(this.tick, 1000);
  }

  componentWillUnmount() {
    if (this.tmr) clearTimeout(this.tmr);
  }

  tick = () => {
    const { count } = this.state;
    const newCount = count - 1;
    this.setState({ count: newCount });
    if (newCount < 1) {
      this.redirect();
      clearTimeout(this.tmr);
    }
  }

  handleRedirectNow = (e) => {
    e.preventDefault();
    this.redirect();
  }

  redirect = () => {
    const { redirect_url } = this.state;
    window.location = redirect_url;
  }

  render() {
    const { count } = this.state;
    return (
      <div className="bg-info text-white text-center d-flex justify-content-center align-items-center h-100 w-100" style={{ position: 'fixed' }}>
        <div>
          <div className="checkmark-wrapper">
            <div className="checkmark-icon">
              <svg
                version="1.1"
                id="Layer_1"
                xmlns="http://www.w3.org/2000/svg"
                x="0px"
                y="0px"
                viewBox="0 0 161.2 161.2"
                enableBackground="new 0 0 161.2 161.2"
                xmlSpace="preserve"
              >
                <path
                  className="path"
                  fill="none"
                  stroke="#17aa1c"
                  strokeMiterlimit="10"
                  d="M425.9,52.1L425.9,52.1c-2.2-2.6-6-2.6-8.3-0.1l-42.7,46.2l-14.3-16.4c-2.3-2.7-6.2-2.7-8.6-0.1c-1.9,2.1-2,5.6-0.1,7.7l17.6,20.3c0.2,0.3,0.4,0.6,0.6,0.9c1.8,2,4.4,2.5,6.6,1.4c0.7-0.3,1.4-0.8,2-1.5c0.3-0.3,0.5-0.6,0.7-0.9l46.3-50.1C427.7,57.5,427.7,54.2,425.9,52.1z"
                />
                <circle className="circle path" fill="none" stroke="#ffffff" strokeWidth="7" strokeMiterlimit="10" cx="80.6" cy="80.6" r="62.1" />
                <polyline
                  className="check"
                  fill="none"
                  stroke="#ffffff"
                  strokeWidth="7"
                  strokeLinecap="round"
                  strokeMiterlimit="10"
                  points="113,52.8 74.1,108.4 48.2,86.4 "
                />

              </svg>
            </div>
          </div>
          <h4>Transaction Complete</h4>
          <div>
            <h6>Redirecting in <b>{ count }</b>...</h6>
            <a href="/" className="btn btn-secondary" onClick={this.handleRedirectNow}><small>Redirect now</small></a>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, { match }) => ({
  inquiry_no: match.params.inquiry_no,
});

export default connect(mapStateToProps)(PaySuccess);
